<template>
    <div>
        <span>
            <!-- link to the previous page before 'track bucket' -->
            <a href="#" @click.prevent.stop="$router.go(-1)">
                <i class="fas fa-arrow-left"></i>
            </a>
            <span class="title-separator">|</span>
            <PlayButton class="control" :track="currentTrack"></PlayButton>
            <span>
                <span v-if="isLoadingTrack===true">Loading Track ...</span>
                <span v-else-if="currentTrack!=null">
                    {{currentTrack.title||'[No Title]'}} <span class="by" v-if="currentTrack.artist">by {{ currentTrack.artist }}</span>
                </span>
                <span v-else>Track Mix</span>
            </span>
        </span>
    </div>
</template>

<style lang="scss" scoped>
    .by {
        color: #D2D2D2;
        font-size: 16px;
        line-height: 1;
        align-self: flex-end;
        padding-bottom: 2px;
        margin-left: 12px;
    }
    .control{
        margin-right: 10px !important;
        font-size: 12px !important;
        border-radius: 3px;
        background: #8c8c8c;
        padding: 5px !important;
        color: var(--light);
    }
</style>

<script>
    import { mapState } from 'vuex'
    import PlayButton from "@/components/common/PlayButton";

    export default {
        name: 'TrackHeader',
        components: {PlayButton},
        computed: {
            ...mapState('tracks', ['isLoadingTrack', 'currentTrack']),
        },
    }
</script>
